import { useNavigate } from "react-router-dom";
import "../styles/Home.css";
import logo_main from "../img/logo_main.png";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import store from "../store";

const { config } = require("../settings");

export default function Home() {
    const storeRoutes = store.getState().routes;
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const changeRoute = (event) => {
        let tabName = event.target.name;
        const currentCity = Object.keys(store.getState().cities.listCities)[0];
        navigate("/sump/" + tabName + "/" + currentCity);
    };

    const importAllLogos = (r) => {
        return r.keys().map(r);
    };
    const listLogos = importAllLogos(
        require.context("../img/", false, /\/logo0.*_.*\.(png|jpe?g|svg)$/),
    );
    const tabs = [
        {
            label: "sump-management",
            display: storeRoutes.displayTabSumpManagement,
        },
        {
            label: "sump-trajectory",
            display: storeRoutes.displayTabSumpTrajectory,
        },
        {
            label: "mobility-indicators",
            display: storeRoutes.displayTabMobilityIndicators,
        },
        {
            label: "digital-participation",
            display: storeRoutes.displayTabDigitalParticipation,
        },
    ];

    return (
        <div className="home-container">
            <div className="home-content home-content-width">
                <div className="home-header">
                    <img
                        className="logo-main"
                        src={logo_main}
                        alt="logo_main"
                    />
                    <h1
                        className="home-title"
                        dangerouslySetInnerHTML={{
                            __html: t(config.home.title),
                        }}
                    ></h1>
                    <div className="home-tabs-container">
                        {tabs.map((tab, i) =>
                            tab.display === true ? (
                                <div key={i}>
                                    <button
                                        className={
                                            `home-tabs-button home-tabs-button-` +
                                            tab.label
                                        }
                                        style={{
                                            backgroundImage: `url(${require(`../img/tab${i}_${i18n.resolvedLanguage}.png`)})`,
                                        }}
                                        onClick={changeRoute}
                                        name={tab.label}
                                    ></button>
                                </div>
                            ) : null,
                        )}
                    </div>
                    <div
                        className="home-help"
                        dangerouslySetInnerHTML={{
                            __html: t(config.home.help),
                        }}
                    ></div>
                </div>

                <div
                    className="home-speech"
                    dangerouslySetInnerHTML={{
                        __html: t(config.home.speech),
                    }}
                ></div>
            </div>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    p: 3,
                    m: "50px 0px 0px 0px",
                    bgcolor: "#9e0b26",
                }}
            >
                {listLogos.map((image, index) => (
                    <Grid item xs={3} key={index} p="5px 40px">
                        <img key={index} src={image} alt="logo"></img>
                    </Grid>
                ))}
            </Box>
        </div>
    );
}
